import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { MINUTES } from '@sequencehq/utils/dates'
import { useQueries } from '@tanstack/react-query'
import { CREDIT_NOTE_STATUSES } from 'CreditNotes/constants'
import { CreditNote } from 'CreditNotes/types'

export const useNonVoidedCreditNotes = ({
  creditNoteIds
}: {
  creditNoteIds: string[]
}): { creditNotes: CreditNote[] } => {
  const creditNoteQueries = useQueries({
    queries: creditNoteIds.map(id => ({
      queryKey: [...dashboardv99990101Client.getCreditNote.queryKey, { id }],
      queryFn: async () => {
        const res = await dashboardv99990101Client.getCreditNote.request({ id })

        if (res.error) {
          return Promise.reject(res)
        }

        return res.data ?? null
      },
      staleTime: 1 * MINUTES
    }))
  })

  const creditNotes = creditNoteQueries.flatMap(query => {
    const creditNote = query.data

    if (!creditNote || creditNote.status === CREDIT_NOTE_STATUSES.VOIDED) {
      return []
    }

    return [creditNote]
  })

  return { creditNotes }
}
